export default __webpack_public_path__ + "static/zilverring-0fed95795495afe62f260fb23d34cace.png";